// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

import awsJson from '../services/aws.json';
import { ResourcesConfig } from 'aws-amplify';

const config: ResourcesConfig = {
    API: {
        GraphQL: {
            endpoint: awsJson.ApiEndpoint,
            region: awsJson.region,
            defaultAuthMode: 'userPool',
        }
    },
    Auth: {
        Cognito: {
            userPoolId: awsJson.UserPoolId,
            userPoolClientId: awsJson.UserPoolClientId,
        }
    }
};

export default config;